import { useContext } from "react"
import { GetApp } from "../../App"
import { PrintShipViewContext } from "../../App/Context"
import { BlockField, BlockRow } from "../../Components/Block"
import { PrintListBlock } from "../../Components/PrintListBlock"
import { IShipUserCrewRole } from "../../Types"
import { PrintShipViewData } from "./Context"
import { PrintShipUsersViewProps } from "./Params"

// Crew list. Rendered only when the user opts into the user list.
export function PrintShipUsersView({ users }: PrintShipUsersViewProps) {
  const app = GetApp();
  const tt = app.getT("ShipSettingsView");

  const context = useContext(PrintShipViewContext);
  const includeUserList = context?.includeUserList || false;

  const getCrewRoleText = (role: IShipUserCrewRole) => PrintShipViewData.crewRoleText(tt, role);

  return (
    <PrintListBlock title={tt("tab_ship_user")} visible={includeUserList} blockClassName="ShipUserPrintView">
      {PrintShipViewData.sortShipUsers(users).map((user, index) => (
        <BlockRow key={user.id || index} className="ShipUserPrintView-row block-row-no_labels">
          <BlockField label={index === 0 ? tt("user_name") : undefined} className="block-field-210">{user.name}</BlockField>
          <BlockField label={index === 0 ? tt("user_shortname") : undefined} className="block-field-120">{user.shortname}</BlockField>
          <BlockField label={index === 0 ? tt("user_crew_role") : undefined} className="block-field-120">{getCrewRoleText(user.shipUserCrewRole)}</BlockField>
          {/* <BlockField label={tt("ship_user_level")} className="block_field_small_16">{getUserLevelText(user.shipUserLevel)}</BlockField> */}
        </BlockRow>
      ))}
    </PrintListBlock>
  );
}
